import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import Table from 'react-bootstrap/Table';

import { getPageNums } from "./pagination";

const UserRecordsTable = ({ records, label, loading, error, debouncedSearch, pagination, onPageChange, onEdit, onDeleteRequest }) => {
    if (loading) return <div className="text-center py-5"><Spinner animation="border" /></div>;
    if (error)   return <Alert variant="danger">{error}</Alert>;
    if (records.length === 0) {
        return <Alert variant="info">{debouncedSearch ? `No ${label}s match "${debouncedSearch}".` : `No ${label}s found.`}</Alert>;
    }

    return (
        <>
            <Table hover responsive className="align-middle">
                <thead className="table-light">
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Subscription</th>
                        <th>Status</th>
                        <th>Joined</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {records.map(r => (
                        <tr key={r.guid}>
                            <td>{r.user.first_name} {r.user.last_name}</td>
                            <td>{r.user.email}</td>
                            <td><span className="font-monospace small">{r.subscription_type || '—'}</span></td>
                            <td>
                                <Badge bg={r.user.activated ? 'success' : 'secondary'} pill>
                                    {r.user.activated ? 'active' : 'inactive'}
                                </Badge>
                            </td>
                            <td><small className="text-muted">{new Date(r.user.created_at).toLocaleDateString()}</small></td>
                            <td className="text-end">
                                <Button size="sm" variant="outline-primary" className="me-2" onClick={() => onEdit(r)}>Edit</Button>
                                <Button size="sm" variant="outline-danger" onClick={() => onDeleteRequest(r)}>Delete</Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {pagination && pagination.totalPages > 1 && (
                <div className="d-flex justify-content-between align-items-center mt-3">
                    <small className="text-muted">
                        Page {pagination.pageNumber} of {pagination.totalPages} ({pagination.total} total)
                    </small>
                    <div className="d-flex gap-1 flex-wrap align-items-center">
                        <Button size="sm" variant="outline-secondary" disabled={!pagination.hasPreviousPage} onClick={() => onPageChange(pagination.pageNumber - 1)}>←</Button>
                        {getPageNums(pagination.pageNumber, pagination.totalPages).reduce((acc, p, i, arr) => {
                            if (i > 0 && p - arr[i - 1] > 1) acc.push(<span key={`gap-${p}`} className="px-1 text-muted">…</span>);
                            acc.push(
                                <Button key={p} size="sm" variant={p === pagination.pageNumber ? 'secondary' : 'outline-secondary'} onClick={() => onPageChange(p)}>{p}</Button>
                            );
                            return acc;
                        }, [])}
                        <Button size="sm" variant="outline-secondary" disabled={!pagination.hasNextPage} onClick={() => onPageChange(pagination.pageNumber + 1)}>→</Button>
                    </div>
                </div>
            )}
        </>
    );
};

export default UserRecordsTable;
